import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "c404ezdPU5A+4HVU9xiUFyp", "Fail", undefined);

import { _decorator, Component, Node, Label, v3, UITransform, PhysicsSystem } from 'cc';
import { Ball } from './Ball';
import ScaleAct from './common/actionItem/ScaleAct';
import { E_ADUrl } from './common/ad/AdCtr';
import { E_ADEventType, E_AdType, E_EventType, E_GameState, E_MainLayerType, E_PlatformType, NodeInWindow_Pos } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_MusicType, E_SoundType } from './common/manager/SoundManager';
import { LinkOut } from './LinkOut';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Fail = (_dec = ccclass('Fail'), _dec2 = property(Node), _dec3 = property(Node), _dec4 = property(Label), _dec5 = property(Node), _dec6 = property(Node), _dec7 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Fail, _Component);

  function Fail() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_bg", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_lvBg", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_lv", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ad", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_home", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_logo", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isReborn", false);

    return _this;
  }

  var _proto = Fail.prototype;

  _proto.onLoad = function onLoad() {
    this.n_lvBg.getComponent(UITransform).width = App.DataMgr.visibleSize.width;
    App.CommonAmn.recordInitPos(this.n_lvBg);
    App.CommonAmn.recordInitPos(this.lbl_lv.node);
    App.CommonAmn.recordInitPos(this.n_ad);
    App.CommonAmn.recordInitPos(this.n_home);
    App.CommonAmn.recordExitPosByType(this.n_lvBg, NodeInWindow_Pos.Left);
    App.CommonAmn.recordExitPosByType(this.n_ad, NodeInWindow_Pos.Right);
    App.CommonAmn.recordExitPosByType(this.lbl_lv.node, NodeInWindow_Pos.Left);
    App.CommonAmn.recordExitPosByType(this.n_home, NodeInWindow_Pos.Right);
  };

  _proto.start = function start() {
    // [3]
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
    this.addEventListener();
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListener = function addEventListener() {
    App.AdEventMgr.addEventLintener(E_ADEventType.video_showOver, this.handle_adSucc, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.AdEventMgr.removeEvent(this);
  };

  _proto.handle_adSucc = function handle_adSucc() {
    if (App.AdCtrl.type == E_AdType.Reborn) {
      var _App$GameCtrl$ball_ga;

      App.MapCtr.removeColliderInView();
      (_App$GameCtrl$ball_ga = App.GameCtrl.ball_game.getComponent(Ball)) === null || _App$GameCtrl$ball_ga === void 0 ? void 0 : _App$GameCtrl$ball_ga.reborn();
      PhysicsSystem.instance.enable = false;
      PhysicsSystem.instance.fixedTimeStep = 1 / 60;
      PhysicsSystem.instance.resetAccumulator(0);
      this._isReborn = true;
      App.EventMgr.handleEvent(E_EventType.Line_Reset);
      this.exit();
    }
  };

  _proto.enter = function enter() {
    var _this2 = this;

    this.n_logo.active = App.AdCtrl.platformType != E_PlatformType.XiaoMi;
    App.SoundMgr.playEffectType(E_SoundType.Fail);
    this._isReborn = false;
    App.CommonAmn.act_dir2Init_node(this.n_lvBg, NodeInWindow_Pos.Left, 0, 0.25, "backOut");
    App.CommonAmn.act_dir2Init_node(this.lbl_lv.node, NodeInWindow_Pos.Left, 0.1, 0.25, "backOut");
    App.CommonAmn.act_fade(this.n_bg, 0, 0.5, 0, 160);
    var pos_home = App.CommonAmn.getInitPos(this.n_home);
    this.n_home.setPosition(v3(pos_home.x, pos_home.y, 0));
    var pos_ad = App.CommonAmn.getInitPos(this.n_ad);
    this.n_ad.setPosition(v3(pos_ad.x, pos_ad.y, 0));
    App.CommonAmn.act_fadeByActive(this.n_home, 1.5, 0.5, 0, 255);
    App.CommonAmn.act_fadeByActive(this.n_ad, 0.5, 0.5, 0, 255, "", function () {
      var _this2$n_ad$getCompon;

      (_this2$n_ad$getCompon = _this2.n_ad.getComponent(ScaleAct)) === null || _this2$n_ad$getCompon === void 0 ? void 0 : _this2$n_ad$getCompon.act();
    });
    App.SoundMgr.stopMusic();
    App.GameCtrl.n_link.getComponent(LinkOut).enter(); //关卡等级

    this.lbl_lv.string = "LEVEL " + (App.DataMgr.tollgateLv + 1);
  };

  _proto.exit = function exit() {
    var _this3 = this;

    App.GameCtrl.isSwitch = true;
    App.CommonAmn.act_fade(this.n_bg, 0, 0.5, 160, 0);
    App.CommonAmn.act_exit(this.n_lvBg, 0, 0.5, "backIn");
    App.CommonAmn.act_exit(this.lbl_lv.node, 0, 0.5, "backIn");
    App.CommonAmn.act_exit(this.n_ad, 0, 0.5, "backIn");
    App.CommonAmn.act_exit(this.n_home, 0, 0.5, "backIn", function () {
      if (_this3._isReborn) {
        _this3.node.active = false;
        App.GameCtrl.gameState = E_GameState.Gaming;
      } else {
        App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Hall);
      }

      App.GameCtrl.isSwitch = false;
      App.SoundMgr.playMusicType(E_MusicType.Hall);
    });
    App.GameCtrl.n_link.getComponent(LinkOut).exit();
  };

  _proto.btn_event = function btn_event(btn) {
    switch (btn.node.name) {
      case "n_ad":
        App.AdCtrl.type = E_AdType.Reborn;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "n_home":
        this.exit();
        break;

      case "n_logo":
        window.open(E_ADUrl.Dob5_URL, "_self");
        break;
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return Fail;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_bg", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_lvBg", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "lbl_lv", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_ad", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "n_home", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "n_logo", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();